import React from 'react';

const ControlValveDiaphragmIcon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737',
  fillPercent = 0,
  fillColor = '#22c55e'
}) => {
  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 67 112.5"
      className={className}
    >

<g id={`${uid}_1`}>
	<path fill={`${midColor}`} d="M11.6,64.978h2.59v1.351H11.6V64.978z" />
	<path fill={`${midColor}`} d="M18.243,38.063H7.207v7.657h11.036V38.063z" />
	<path fill={`${midColor}`} d="M30.855,30.856h7.883v3.941h-7.883V30.856z" />
	<path fill={`${midColor}`} d="M24.099,38.063h2.027v10.022h-2.027V38.063z" />
	<path fill={`${endColor}`} d="M23.536,45.383V44.82h4.617V32.771h13.625v0.676h-12.95v11.937H23.536z" />
	<path fill={`${endColor}`} d="M18.243,39.415h8.559v1.352h-8.559V39.415z" />
	<path fill={`${midColor}`} d="M43.13,26.802h5.293v11.261H43.13V26.802z" />
	<path fill={`${midColor}`} d="M32.094,56.419h5.743v3.941h-5.743V56.419z" />
	<path fill={`${midColor}`} d="M7.207,54.392v2.027h1.352h8.333h1.352v-2.027H7.207z" />
	<path fill={`${midColor}`} d="M8.559,56.419c0,0,0-1.294,4.275-1.294c4.058,0,4.058,1.294,4.058,1.294v8.559H8.559V56.419z" />
	<path fill={`${endColor}`} d="M18.243,45.721H7.207v8.671h11.036V45.721z" />
	<circle fill={`${endColor}`} cx="45.72" cy="34.122" r="1.351" />
	<rect x="45.579" y="32.771" fill={`${endColor}`} width="0.281" height="2.702" />
</g>
<g id={`${uid}_2`}>
	<linearGradient id={`${uid}_3`} gradientUnits="userSpaceOnUse" x1="32.7695" y1="45.7178" x2="36.8242" y2="45.7178">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.49" style={{stopColor: `${midColor}`}} />
		<stop offset="0.56" style={{stopColor: `${midColor}`}} />
		<stop offset="0.71" style={{stopColor: `${midColor}`}} />
		<stop offset="0.92" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_3)`} d="M32.77,34.798h4.055v21.839H32.77V34.798z" />
</g>
<g id={`${uid}_4`}>
	<path fill={`${midColor}`} d="M13.514,38.063c0,0-4.633-7.018-6.193-9.347c-1.026-1.532-3.119-4.604-3.829-6.306   c-0.357-0.857-0.901-3.604-0.901-3.604S1.536,7.247,3.941,4.618c1.561-1.706,6.982-1.352,6.982-1.352h21.17V0.564H10.248   c0,0-4.622-0.358-6.869,1.126C0.448,3.627,0,7.434,0,7.434s0,6.771,0,12.725c0,1.006,0.787,2.931,1.239,3.829   c0.869,1.725,3.24,5.104,4.302,6.718c1.263,1.919,5.044,7.358,5.044,7.358H13.514z" />
	<path fill={`${midColor}`} d="M37.387,5.294V0.001h-5.293v3.941h1.352v1.352H37.387z" />
	<path fill={`${midColor}`} d="M30.855,0.001h-3.378v3.941h3.378V0.001z" />
	
		<rect x="33.111" y="3.166" transform="matrix(0.7036 -0.7106 0.7106 0.7036 7.727 25.1483)" fill={`${endColor}`} width="1.791" height="0.292" />
</g>
<g id={`${uid}_5`}>
	<path fill={`${endColor}`} d="M30.855,60.36h7.883v1.351h-7.883V60.36z" />
	<linearGradient id={`${uid}_6`} gradientUnits="userSpaceOnUse" x1="24.0986" y1="109.1777" x2="45.7197" y2="109.1777">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.62" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_6)`} d="M24.099,105.855H45.72v6.644H24.099V105.855z" />
	<linearGradient id={`${uid}_7`} gradientUnits="userSpaceOnUse" x1="24.0986" y1="71.416" x2="45.7197" y2="71.416">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.62" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_7)`} d="M24.099,68.243H45.72v6.345H24.099V68.243z" />
	<linearGradient id={`${uid}_8`} gradientUnits="userSpaceOnUse" x1="28.1533" y1="63.6816" x2="41.7783" y2="63.6816">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.62" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_8)`} d="M28.153,61.711h13.625v3.941H28.153V61.711z" />
	<linearGradient id={`${uid}_9`} gradientUnits="userSpaceOnUse" x1="24.0986" y1="76.2949" x2="45.7197" y2="76.2949">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_9)`} d="M24.099,73.648H45.72v5.293H24.099V73.648" />
	<linearGradient id={`${uid}_10`} gradientUnits="userSpaceOnUse" x1="34.9658" y1="77.5898" x2="34.9658" y2="107.0938">
		<stop offset="0" style={{stopColor: `${midColor}`}} />
		<stop offset="0.29" style={{stopColor: `${midColor}`}} />
		<stop offset="0.91" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_10)`} d="M24.099,77.59v2.703l-1.238,1.238h-5.293l-1.352-1.238v24.211l1.352-1.352h5.293l1.238,1.352v2.59   H45.72v-2.59l1.352-1.352h5.293l1.352,1.352V80.293l-1.352,1.238h-5.293l-1.352-1.238V77.59H24.099z" />
	<linearGradient id={`${uid}_11`} gradientUnits="userSpaceOnUse" x1="56.3613" y1="105.8555" x2="56.3613" y2="78.9414">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<polygon fill={`url(#${uid}_11)`} points="53.716,78.941 53.716,85.923 53.716,96.508 53.716,105.855 59.008,105.855 59.008,96.508    59.008,85.923 59.008,78.941  " />
	<linearGradient id={`${uid}_12`} gradientUnits="userSpaceOnUse" x1="13.5698" y1="105.8555" x2="13.5698" y2="78.9414">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${midColor}`}} />
		<stop offset="0.77" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<polygon fill={`url(#${uid}_12)`} points="10.924,78.941 10.924,85.923 10.924,96.508 10.924,105.855 16.216,105.855 16.216,96.508    16.216,85.923 16.216,78.941  " />
	
		<radialGradient id={`${uid}_13`} cx="34.9102" cy="92.3418" r="9.459" gradientTransform="matrix(-4.371139e-008 -1 3 -1.311342e-007 -242.1152 127.252)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: `${midColor}`}} />
		<stop offset="0.14" style={{stopColor: `${midColor}`}} />
		<stop offset="0.4" style={{stopColor: `${midColor}`}} />
		<stop offset="0.75" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</radialGradient>
	<path fill={`url(#${uid}_13)`} d="M44.369,101.801c0,0-0.901-5.089-0.901-9.459c0-4.046,0.901-9.459,0.901-9.459   s-5.158,1.352-9.459,1.352c-4.074,0-9.46-1.352-9.46-1.352s1.014,4.079,1.014,9.239c0,5.007-1.014,9.679-1.014,9.679   s5.386-1.014,9.46-1.014C38.919,100.787,44.369,101.801,44.369,101.801z" />
</g>
<g id={`${uid}_14`}>
	<linearGradient id={`${uid}_15`} gradientUnits="userSpaceOnUse" x1="18.8066" y1="47.0278" x2="51.0127" y2="47.0278">
		<stop offset="0" style={{stopColor: `${endColor}`}} />
		<stop offset="0.06" style={{stopColor: `${midColor}`}} />
		<stop offset="0.07" style={{stopColor: `${midColor}`}} />
		<stop offset="0.09" style={{stopColor: `${midColor}`}} />
		<stop offset="0.12" style={{stopColor: `${midColor}`}} />
		<stop offset="0.14" style={{stopColor: `${endColor}`}} />
		<stop offset="0.15" style={{stopColor: `${endColor}`}} />
		<stop offset="0.52" style={{stopColor: `${midColor}`}} />
		<stop offset="0.82" style={{stopColor: `${endColor}`}} />
		<stop offset="0.94" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_15)`} d="M18.807,30.856l1.351-2.815l2.928-2.14l10.36-0.089v3.692h-8.671l-2.59,2.027V62.95l3.266,2.027   h20.27l2.027-3.378V31.532l-2.703-2.027h-8.896v-3.567l11.091,0.02l2.575,2.481l1.198,2.418v33.445l-1.576,3.04l-2.703,0.901   h-2.364H24.099l-3.604-0.901l-1.688-3.04V30.856z" />
</g>
<g id={`${uid}_16`}>
	<path fill={`${endColor}`} d="M29.504,26.802H40.09v4.054H29.504V26.802z" />
	<linearGradient id={`${uid}_17`} gradientUnits="userSpaceOnUse" x1="8.2207" y1="16.0479" x2="61.7109" y2="16.0479">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${endColor}`}} />
		<stop offset="0.56" style={{stopColor: `${endColor}`}} />
		<stop offset="0.76" style={{stopColor: `${startColor}`}} />
		<stop offset="0.77" style={{stopColor: `${startColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<polygon fill={`url(#${uid}_17)`} points="59.008,5.294 10.36,5.294 8.221,7.884 8.221,24.663 10.924,26.802 59.571,26.802    61.711,24.1 61.711,7.884  " />
	{(() => {
		const pct = Math.min(100, Math.max(0, fillPercent));
		const fillH = 21.508 * pct / 100;
		const fillY = 26.802 - fillH;
		return pct > 0 ? (
			<>
				<defs>
					<clipPath id={`${uid}_capClip`}>
						<polygon points="59.008,5.294 10.36,5.294 8.221,7.884 8.221,24.663 10.924,26.802 59.571,26.802 61.711,24.1 61.711,7.884" />
					</clipPath>
					<linearGradient id={`${uid}_capFill`} x1="0" y1="1" x2="0" y2="0">
						<stop offset="0%" stopColor={fillColor} stopOpacity="0.95" />
						<stop offset="100%" stopColor={fillColor} stopOpacity="0.6" />
					</linearGradient>
				</defs>
				<rect x="6" y={fillY} width="58" height={fillH}
					fill={`url(#${uid}_capFill)`}
					clipPath={`url(#${uid}_capClip)`}
					style={{ transition: 'y 0.5s ease, height 0.5s ease' }} />
				<line x1="6" y1={fillY} x2="64" y2={fillY}
					stroke={fillColor} strokeWidth="1.5" strokeOpacity="0.9"
					clipPath={`url(#${uid}_capClip)`}
					style={{ transition: 'y1 0.5s ease, y2 0.5s ease' }} />
				<rect x="6" y="5.294" width="58" height={fillY - 5.294}
					fill="rgba(0,0,0,0.35)"
					clipPath={`url(#${uid}_capClip)`}
					style={{ transition: 'height 0.5s ease' }} />
			</>
		) : (
			<>
				<defs>
					<clipPath id={`${uid}_capClip`}>
						<polygon points="59.008,5.294 10.36,5.294 8.221,7.884 8.221,24.663 10.924,26.802 59.571,26.802 61.711,24.1 61.711,7.884" />
					</clipPath>
				</defs>
				<rect x="6" y="5.294" width="58" height="21.508" fill="rgba(0,0,0,0.35)" clipPath={`url(#${uid}_capClip)`} />
			</>
		);
	})()}
	<path fill={`${midColor}`} d="M3.941,20.156h2.59v-8.331h-2.59V20.156z" />
	<path fill={`${midColor}`} d="M62.949,20.156h2.703v-8.331h-2.703V20.156z" />
	<path fill={`${midColor}`} d="M33.445,20.156h2.703v-8.331h-2.703V20.156z" />
	<path fill={`${midColor}`} d="M13.514,20.156h2.702v-8.331h-2.702V20.156z" />
	<path fill={`${midColor}`} d="M22.86,20.156h2.59v-8.331h-2.59V20.156z" />
	<path fill={`${midColor}`} d="M44.369,20.156h2.702v-8.331h-2.702V20.156z" />
	<path fill={`${midColor}`} d="M53.716,20.156h2.702v-8.331h-2.702V20.156z" />
	<path fill={`${endColor}`} d="M2.59,13.177h64.414v2.703H2.59V13.177z" />
	<path fill={`${endColor}`} d="M2.59,15.879h64.414v2.928H2.59V15.879z" />
</g>
    </svg>
  );
};

export default ControlValveDiaphragmIcon;
